import { Event } from './event.js';

export class IbanCalculator extends Event {
    constructor(accountnumber, bankcode) {
        super();
        this._accountnumber = document.querySelector(accountnumber);
        this._bankcode = document.querySelector(bankcode);
        this._ibancalculator = document.querySelector('#ibancalculator');
        this._toggleButton = document.querySelector('.iban-calculator');
        this._errorElement = document.querySelector('.field-payment-bankcode > div.text-danger');
        this._request = new Request('POST', '/service-payment/generate-iban');
        this.init();
    };

    init() {
        if(this._toggleButton) {
            this._toggleButton.addEventListener('click', () => {
                this._ibancalculator.classList.toggle('d-none');
            });

            this._accountnumber.addEventListener('blur', () => {
                this.generateIban();
            });
    
            this._bankcode.addEventListener('blur', () => {
                this.generateIban();
            });
        }
    }

    generateIban() {
        if(this._accountnumber.value != "" && this._bankcode.value != "") {

            this.fireEvent('updateIban', {
                value : '',
                placeholder: 'errechne IBAN...'
            });
            
            this._request.data = {
                'Payment[bankcode]' : this._bankcode.value,
                'Payment[accountnumber]' : this._accountnumber.value
            };
            this._request.call(response => {
                if (response.status == 'ok') {
                    this.success(OVS.app.helper.formatIBAN(response.iban));
                } else {
                    this.error();
                }
            });
        }
    };

    success(iban) {
        this._ibancalculator.classList.toggle('d-none');
        this._accountnumber.value = '';
        this._bankcode.value = '';
        this._errorElement.innerHTML = '';
        this.fireEvent('updateIban', {
            value : iban,
            placeholder: 'IBAN'
        });
    }

    error() {
        this._errorElement.innerHTML = 'Bitte prüfen Sie ihre Eingabe';
        this.fireEvent('updateIban', {
            value : '',
            placeholder: 'IBAN'
        });
    }
}
